import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { IonContent } from '@ionic/angular';
import { parsePhoneNumberFromString } from 'libphonenumber-js';
// stores
import { MerchantStore } from '../../../../core/stores/merchant.store';
import { RestaurantStore } from 'src/app/core/stores/restaurant.store';
// services
import { RouteService } from '../../../../core/services/route.service';
import { BlackoutRange, Merchant, Restaurant, Time, WorkDay, WorkTime } from '../../../../core/models/restaurant.model';
import { DefaultImageColorsModel } from 'src/app/core/models/default-image-colors.model';
// models
// rxjs
import { auditTime, filter, takeUntil } from 'rxjs/operators';
import { Title } from '@angular/platform-browser';
import { FormatDataService } from '../../../../core/services/format-data.service';
import * as moment from 'moment';
import { SwipeGestureService } from 'src/app/core/services/swipe-gesture.service';

@Component({
  selector: 'app-home-group',
  templateUrl: './home-group.component.html',
  styleUrls: ['./home-group.component.scss']
})
export class HomeGroupComponent implements OnInit {

  public defaultImageUrl = './assets/images/restaurant_default_logo.svg';
  public googleMapsImageUrl = './assets/images/google_maps_icon.svg';
  public shareImageUrl = './assets/images/share_icon.svg';
  public arrowUp = './assets/images/caret-up-outline.svg';
  public arrowDown = './assets/images/caret-down-outline.svg';
  public restaurantClosedSign = './assets/images/restaurant_closed_sign.svg';
  public restaurantPreordersSign = './assets/images/preorders_sign.svg';
  public merchant = new Merchant();
  public isHome = false;
  public nextOpenTimeUtc;
  public restaurantLength: number;
  public restaurants: Restaurant[];
  public colorsEnum = DefaultImageColorsModel;
  public isScrollPositionTop = true;
  public blackoutedDays = {};

  private readonly firstRestaurantIndex = 0;

  public chosenRestaurant: Restaurant;

  @ViewChild(IonContent, { static: true }) content: IonContent;

  constructor(
    public router: Router,
    public restaurantStore: RestaurantStore,
    public merchantStore: MerchantStore,
    public routeService: RouteService,
    private route: ActivatedRoute,
    private titleService: Title,
    private formatDataService: FormatDataService,
    private swipeGestureService: SwipeGestureService,
  ) {
  }

  ionViewDidEnter() {
    this.swipeGestureService.swipebackEnabled = false;
  }

  ionViewDidLeave() {
    this.swipeGestureService.swipebackEnabled = true;
  }

  ngOnInit() {
    sessionStorage.removeItem('groupId');
    this.restaurantStore.groupIdForRedirect = null;
    this.restaurantStore.checkRouteContainsDiscountOption();
    this.merchantStore.bootstrapMerchant(this.routeService.getGroupIdLocation());
    this.restaurantStore.bootstrapRestaurants(this.routeService.getGroupIdLocation(), true);

    this.getRestaurants();

    this.restaurantStore.filteredWorkHours$
      .subscribe((result: any) => {
        if (this.restaurants) {
          for (const restaurant of this.restaurants) {
            this.blackoutedDays[restaurant.locationId] = this.formatDataService.formatIfStoreContinueWorking(result[restaurant.locationId]);
          }
        }
      });

    this.restaurantStore.restaurants$
      .pipe(filter(Boolean))
      .subscribe((restaurants: Restaurant[]) => {
        this.restaurantLength = restaurants.length;
        this.restaurants = restaurants;
        if (restaurants.length === 1) {
          const restaurant = restaurants[this.firstRestaurantIndex];
          this.restaurantStore.timezone = restaurants[this.firstRestaurantIndex].timezone;
          this.goToRestaurantPage(restaurant);
        }
        if (this.restaurantStore.filteredWorkHours) {
          this.restaurantStore.timezone = restaurants[this.firstRestaurantIndex].timezone;
          for (const restaurant of restaurants) {
            this.blackoutedDays[restaurant.locationId] = this.formatDataService.formatIfStoreContinueWorking(this.restaurantStore.filteredWorkHours[restaurant.locationId]);
          }
        }
      });

    this.content.ionScroll.pipe(auditTime(200)).subscribe((event) => this.trackScroll(event));

    this.merchantStore.merchantData$
      .pipe(filter(Boolean))
      .subscribe((merchant: Merchant) => {
        this.merchant = merchant;
        if (this.merchant.merchantName) {
          this.titleService.setTitle(this.merchant.merchantName);
        }
      });

    /*const modeValue = this.route.snapshot.queryParams.mode;

    if (!localStorage.getItem('mode')) {
      localStorage.setItem('mode', modeValue);
    }*/
  }

  public getLocationImage(restaurant: Restaurant): string {
    return restaurant.locationImageUrl || restaurant.logoUrl || this.defaultImageUrl;
  }

  public isHideSigns(restaurant): boolean {
    return restaurant.hideAllSigns;
  }

  public async trackScroll(event): Promise<void> {
    const element = await this.content.getScrollElement();
    const offsetForHeader = this.isScrollPositionTop ? 100 : 0;
    const isHideScroll = element.offsetHeight === element.scrollHeight;
    this.isScrollPositionTop = event.detail.scrollTop <= offsetForHeader && !isHideScroll;
  }

  public goToRestaurantPage(restaurant: Restaurant): void {
    this.chosenRestaurant = restaurant;
    this.restaurantStore.selectedLocationInGroup = restaurant.locationId;
    this.nextOpenTimeUtc = restaurant.nextOpenTimeUtc;
    let url = this.routeService.getGroupBaseUrl();
    const baseUrl = url.split('?');

    const urlParams = baseUrl[1] ? baseUrl[1].split('=') : null;
    const param = urlParams ? urlParams[0] : null;
    const value = urlParams ? urlParams[1] : null;

    if (url.split('?')[0]) {
      url = url.split('?')[0];
    }
    this.router.navigate([url], { queryParamsHandling: 'preserve', queryParams: { [param]: value } })
      .catch(error => console.error(error));
  }

  getRestaurantHours(restaurant: Restaurant) {
    const blackoutedWeek = this.blackoutedDays[restaurant.locationId];
    if (blackoutedWeek) {
      const restaurantWeek = [];
      for (const [i] of blackoutedWeek.entries()) {
        restaurantWeek.push(this.getDay(blackoutedWeek, i));
      }
      return restaurantWeek;
    }
  }

  public getDay(restaurantHours: WorkDay[], dayId): string {
    if (restaurantHours) {
      if (restaurantHours[dayId].enable) {
        return `${this.formatDataService.formatWeekDay(restaurantHours[dayId])}   ${this.formatDataService.formatWorkDay(restaurantHours[dayId])}`;
      } else {
        return `${this.formatDataService.formatWeekDay(restaurantHours[dayId])}   Closed ${restaurantHours[dayId].isBlackouted ? `(${restaurantHours[dayId].blackoutDayName})` : ''}`;
      }
    }
  }

  public restaurantAllowScheduledOrders(restaurant): boolean {
    return restaurant.allowScheduledPickups && restaurant.isMobileEnabled;
  }

  public showHoursInfo(restaurant): void {
    event.stopPropagation();
    restaurant.showHoursInfo = !restaurant.showHoursInfo;
  }

  public formatPhoneNumber(phone: string, formatType: string, country: any = 'US'): string {
    if (phone) {
      const phoneNumber = parsePhoneNumberFromString(phone.toString(), country);
      if (formatType === 'national') {
        return phoneNumber.formatNational();
      } else if (formatType === 'international') {
        return phoneNumber.formatInternational();
      }
    }
    return '';
  }

  public openLocationInMaps(location) {
    event.stopPropagation();
    const newTab = window.open(
      `https://www.google.com/maps/place/${location.addressLine},+${location.locality},+${location.postalCode},+${location.country}`,
      '_blank');
    newTab.focus();
  }

  public backToKyooTechPage(): void {
    const baseUrl = this.routeService.getKyooTechPage();
    this.router.navigate([baseUrl])
      .catch(error => console.log(error));
  }

  public redirectToFindMerchantPage(): void {
    const baseUrl = this.routeService.getGroupUrl();
    this.router.navigate([baseUrl])
      .catch(error => console.log(error));
  }
  private getRestaurants(): void {
    this.restaurantStore.getRestaurants()
      .pipe(filter(Boolean))
      .subscribe((restaurants: Restaurant[]) => {
        if (restaurants.length !== 0) {
          this.restaurants = restaurants;
          /*this.getRestaurantsCatalogData(restaurants[0].locationId, restaurants[0].merchantId, 0);
          for (const restaurant of restaurants) {
            this.generateWorkDaysForRestaurants(restaurant.locationId);
          }*/
        }
      });
  }
}
